/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useRef} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import ApplicationRouterContext from "@Contexts/Router";
import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";


import {Redirect} from "react-router-dom";


import {Row, Col, Form} from "react-bootstrap";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormFieldComponent from "@Components/UI/Forms/Field";
import FormFieldInfoLinkComponent from "@Components/UI/Forms/Field/InfoLink";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";
import FormSwitchPageComponent from "@Components/UI/Forms/SwitchPage";


import {LoginFormErrorsInterface} from "@UIPages/NotAuthenticated/Login";


type LoginFormComponentProps = {
    loginFormErrors: LoginFormErrorsInterface;
    formUserLogin: string; formUserLoginHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserPassword: string; formUserPasswordHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    loginFormSubmitHandler(): void
};


export const LoginFormComponent: React.FC<LoginFormComponentProps> = ({
    loginFormErrors, loginFormSubmitHandler,
    formUserLogin, formUserLoginHandler,
    formUserPassword, formUserPasswordHandler
}): JSX.Element | null => {


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);

    if (!ROUTER) return <Redirect to={"/404"} />;


    const REGISTER_PAGE_URL: string = ROUTER.NOT_AUTHENTICATED.REGISTER.URL;
    const PASSWORD_RESET_PAGE_URL: string = ROUTER.NOT_AUTHENTICATED.PASSWORD_RESET.URL;


    return (
        <Col xs={12} className={`login-page-form-component user-form-component`}>
            <Row as={Form} className={`login-page-form user-form`} onSubmit={(e: React.FormEvent) => e.preventDefault()}>

                <FormFieldsGroupComponent>

                    <FormFieldsGroupFieldsComponent>

                        <FormFieldComponent
                            lg={6}
                            fieldValue={formUserLogin}
                            fieldValueHandler={e => formUserLoginHandler(e)}
                            fieldType={"text"} fieldLabel={`Użytkownik`} fieldControlID={`login-form-user-login`}
                            fieldPlaceholder={" "}
                            fieldDisabledStatus={!!REST_API_REQUEST_STATUS}
                            fieldError={loginFormErrors?.formUserLogin}
                            autoComplete={"on"}
                        />

                        <FormFieldComponent
                            lg={6}
                            fieldValue={formUserPassword}
                            fieldValueHandler={e => formUserPasswordHandler(e)}
                            fieldType={"password"} fieldLabel={`Hasło`} fieldControlID={`login-form-user-password`}
                            fieldDisabledStatus={!!REST_API_REQUEST_STATUS}
                            fieldError={loginFormErrors?.formUserPassword}
                            autoComplete={"on"}
                        />

                        <FormFieldInfoLinkComponent
                            linkLabel={`Przypomnij hasło`}
                            linkURL={PASSWORD_RESET_PAGE_URL}
                            linkText={`Nie pamiętasz hasła?`}
                        />

                    </FormFieldsGroupFieldsComponent>

                    <DefaultFormButton

                        buttonText={`Zaloguj się`}
                        clickHandler={() => loginFormSubmitHandler()}
                        controlId={`login-form-submit`}
                        disabled={!!REST_API_REQUEST_STATUS}
                        cssClasses={`login-form-submit`}
                    />

                </FormFieldsGroupComponent>

                <>
                {!!loginFormErrors?.loginProcess &&
                <ErrorMessageComponent messageText={loginFormErrors?.loginProcess} />
                }
                </>

                <FormSwitchPageComponent
                    switchLabel={`Nie masz konta?`}
                    switchButtonURL={REGISTER_PAGE_URL}
                    switchButtonText={`Zarejestruj się`}
                />

            </Row>
        </Col>
    );

};


export default LoginFormComponent;
